export default __webpack_public_path__ + "static/media/check.b3b8d727.svg";